"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var flatten = require("array-flatten");

var combineEvents = function combineEvents() {
  var eventDefs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    eventDefs[_i] = arguments[_i];
  }

  return function (action, prevState, nextState) {
    return flatten(eventDefs.map(function (eventDef) {
      return eventDef(action, prevState, nextState);
    }));
  };
};

exports.default = combineEvents;